import { render, staticRenderFns } from "./makeMoneyTipsModal.vue?vue&type=template&id=3c79c335&scoped=true"
import script from "./makeMoneyTipsModal.vue?vue&type=script&lang=js"
export * from "./makeMoneyTipsModal.vue?vue&type=script&lang=js"
import style0 from "./makeMoneyTipsModal.vue?vue&type=style&index=0&id=3c79c335&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c79c335",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c79c335')) {
      api.createRecord('3c79c335', component.options)
    } else {
      api.reload('3c79c335', component.options)
    }
    module.hot.accept("./makeMoneyTipsModal.vue?vue&type=template&id=3c79c335&scoped=true", function () {
      api.rerender('3c79c335', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/makeMoneyTipsModal.vue"
export default component.exports